import {
	useExperimentalQuery,
	type FetchPolicy,
} from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';
import {
	stringifyPersonalizationAttributes,
	type PersonalizationAttribute,
} from '@confluence/legacy-schema-bridge/entry-points/stringifyPersonalizationAttributes';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import type {
	SitePersonalizationQuery as SitePersonalizationQueryData,
	SitePersonalizationQueryVariables,
} from './__types__/SitePersonalizationQuery';

export const useExperimentalSitePersonalizationQuery = ({
	skip,
	onError,
	variables,
	fetchPolicy,
}: {
	skip?: boolean;
	onError?: (error: ApolloErrorInterop) => void;
	variables: SitePersonalizationQueryVariables;
	fetchPolicy?: FetchPolicy;
}) => {
	return useExperimentalQuery<
		SitePersonalizationQueryData,
		SitePersonalizationQueryVariables,
		{ attributes: PersonalizationAttribute[] | null }
	>({
		url: ({ cloudId }) => `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
		method: 'GET',
		parseResult: (json) => ({
			experimentalSitePersonalization: {
				attributes: stringifyPersonalizationAttributes(json.attributes),
			},
		}),
		skip,
		onError,
		variables,
		fetchPolicy,
	});
};
